import React from "react"
import { makeStyles } from "tss-react/mui"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { UserGroup } from "../pages/Users"

const useStyles = makeStyles()(() => ({
    input: {
        width: "10rem",
    },
}))

type SelectUserGroupDropdownProps = Readonly<{
    userGroupId: UserGroup
    setUserGroupId: React.Dispatch<React.SetStateAction<UserGroup>>
}>

export function SelectUserGroupDropdown({ userGroupId, setUserGroupId }: SelectUserGroupDropdownProps) {
    const { classes } = useStyles()

    return (
        <FormControl className={classes.input}>
            <LocalizedStrict id="company-organization-users-table-header-select-label-user-group">
                <InputLabel id="user-group-select-label">User Group</InputLabel>
            </LocalizedStrict>
            <Select
                labelId="user-group-select-label"
                id="user-group-select"
                value={userGroupId}
                label="User Group"
                onChange={(e) => {
                    setUserGroupId(e.target.value as UserGroup)
                }}
            >
                <MenuItem value={UserGroup.ALL}>
                    <LocalizedStrict id="company-organization-users-table-header-select-item-all">
                        <span>All</span>
                    </LocalizedStrict>
                </MenuItem>
            </Select>
        </FormControl>
    )
}
